// extracted by mini-css-extract-plugin
export default {"wrapper":"ER-z","availablePromoMessagesLabel":"FR-z","promoMessageList":"GR-z","promoMessage":"HR-z","appliedPromoMessage":"IR-z","promoMessageAmount":"JR-z"};